import Image from 'next/image';
import React, { useEffect } from 'react';
import { getScreenName } from '../../../Utils/helper';
import {
  CertificateImageContainer,
  CertificatesContainer,
  CertificatesDiv,
  CertificatesName,
  DesktopShow,
  MobileShow,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function ClothDiaperCertificates(props) {
  const { certificatesData } = props;
  const cardClickHandler = () => {
    fireEvent({
      category: 'clicked_card_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: 'trust_strip_top',
      shape: 'Banner',
      page_url: window.location.href.slice(0, 99),
    });
    // scrollUp();
  };

  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: 'trust_strip_top',
      shape: 'Banner',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);
  return (
    <>
      <MobileShow>
        <CertificatesContainer>
          {certificatesData?.map((data, index) => {
            return (
              <CertificatesDiv
                key={`certificates${index}`}
                onClick={cardClickHandler}
              >
                <CertificateImageContainer>
                  <Image
                    src={data?.image}
                    alt={data?.name}
                    quality={100}
                    fill
                    sizes="100vw"
                  />
                </CertificateImageContainer>
                <CertificatesName>{data?.name}</CertificatesName>
              </CertificatesDiv>
            );
          })}
        </CertificatesContainer>
      </MobileShow>
      <DesktopShow>
        <CertificatesContainer>
          {certificatesData?.map((data, index) => {
            return (
              <CertificatesDiv
                key={`certificates${index}`}
                onClick={cardClickHandler}
              >
                <img
                  src={data?.image}
                  alt={data?.name}
                  layout="fixed"
                  width={32}
                  height={32}
                  quality={100}
                />
                <CertificatesName>{data?.name}</CertificatesName>
              </CertificatesDiv>
            );
          })}
        </CertificatesContainer>
      </DesktopShow>
    </>
  );
}
